// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3-EhB","loaderOuter":"PageOverlayLoader_loaderOuter__1rDui"};